import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AgeGate from './components/AgeGate';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import VideoDetail from './pages/VideoDetail';
import SeriesPage from './pages/Series';
import Login from './pages/Login';
import ErrorPage from './pages/ErrorPage';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import SessionBoundary from './components/SessionBoundary';
import { SkeletonCard, PaymentSkeleton } from './components/LoadingSkeleton';
import './App.css';

// Lazy-load sensitive, administrative, and heavy feature routes so their internal
// route structures, payment handlers, and player logic are split into isolated chunks
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const Payment = lazy(() => import('./pages/Payment'));
const Watch = lazy(() => import('./pages/Watch'));
const DemoPlayer = lazy(() => import('./pages/DemoPlayer'));

function AdminSuspenseFallback() {
  return (
    <div className="admin-loading-fallback" style={{ padding: '60px 20px', maxWidth: '1200px', margin: '0 auto' }}>
      <SkeletonCard />
    </div>
  );
}

function PageSuspenseFallback() {
  return (
    <div className="page-loading-fallback" style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto' }}>
      <PaymentSkeleton />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AgeGate>
        <Router>
          <SessionBoundary>
          <div className="App">
            <Navbar />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/demo"
                  element={
                    <Suspense fallback={<PageSuspenseFallback />}>
                      <DemoPlayer />
                    </Suspense>
                  }
                />
                <Route path="/video/:id" element={<VideoDetail />} />
                <Route
                  path="/payment/:type/:id"
                  element={
                    <Suspense fallback={<PageSuspenseFallback />}>
                      <Payment />
                    </Suspense>
                  }
                />
                <Route
                  path="/watch/:id"
                  element={
                    <Suspense fallback={<PageSuspenseFallback />}>
                      <Watch />
                    </Suspense>
                  }
                />
                <Route path="/series/:id" element={<SeriesPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/401" element={<ErrorPage status={401} />} />
                <Route path="/403" element={<ErrorPage status={403} />} />
                <Route path="/404" element={<ErrorPage status={404} />} />
                <Route
                  path="/admin"
                  element={
                    <AdminProtectedRoute>
                      <Suspense fallback={<AdminSuspenseFallback />}>
                        <AdminDashboard />
                      </Suspense>
                    </AdminProtectedRoute>
                  }
                />
                <Route path="*" element={<ErrorPage status={404} />} />
              </Routes>
            </main>
            <Footer />
          </div>
          </SessionBoundary>
        </Router>
      </AgeGate>
    </AuthProvider>
  );
}

export default App;
